import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Timestamps are stored in UTC; always display them in IST regardless of the
// viewer's device timezone.
const IST_FORMAT = new Intl.DateTimeFormat("en-IN", {
  timeZone: "Asia/Kolkata",
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
});

const IST_DATE_FORMAT = new Intl.DateTimeFormat("en-IN", {
  timeZone: "Asia/Kolkata",
  day: "2-digit",
  month: "short",
  year: "numeric",
});

export function formatIST(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return IST_FORMAT.format(d);
}

export function formatISTDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return IST_DATE_FORMAT.format(d);
}

// Canonical doctor display name: strips any existing "Dr"/"DR." prefix,
// title-cases the rest, and prefixes "Dr. " — so "DR.K.SARAVANAN" and
// "manoj warule" both render consistently ("Dr. K.Saravanan", "Dr. Manoj Warule").
export function displayDoctorName(name) {
  const raw = (name || "").trim().replace(/^dr\.?\s*/i, "");
  if (!raw) return "";
  const titled = raw.replace(/[A-Za-z]+/g, (w) => w[0].toUpperCase() + w.slice(1).toLowerCase());
  return `Dr. ${titled}`;
}
